var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _rect2, _rect3, _rect4, _path26, _path27, _path28, _path29;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuilding2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 293,
    viewBox: "0 0 160 293",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 293,
    fill: "#201B1B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108 140H152V154H130H108V140Z",
    fill: "#D27723"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108 140H152V154H108V140Z",
    fill: "#D27723"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108 166H152V180H130H108V166Z",
    fill: "#D27723"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108 166H152V180H108V166Z",
    fill: "#D27723"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108 192H152V206H130H108V192Z",
    fill: "#D27723"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108 192H152V206H108V192Z",
    fill: "#D27723"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M108 218H152V232H130H108V218Z",
    fill: "#D27723"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M108 218H152V232H108V218Z",
    fill: "#D27723"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M108 88H152V102H130H108V88Z",
    fill: "#D27723"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M108 88H152V102H108V88Z",
    fill: "#D27723"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M108 62H152V76H130H108V62Z",
    fill: "#D27723"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M108 62H152V76H108V62Z",
    fill: "#D27723"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M108 114H152V128H130H108V114Z",
    fill: "#D27723"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M108 114H152V128H108V114Z",
    fill: "#D27723"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M8 140H52V154H30H8V140Z",
    fill: "#D27723"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8 140H52V154H8V140Z",
    fill: "#D27723"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8 166H52V180H30H8V166Z",
    fill: "#D27723"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M8 166H52V180H8V166Z",
    fill: "#D27723"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M8 192H52V206H30H8V192Z",
    fill: "#D27723"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M8 192H52V206H8V192Z",
    fill: "#D27723"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M8 218H52V232H30H8V218Z",
    fill: "#D27723"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M8 218H52V232H8V218Z",
    fill: "#D27723"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M8 88H52V102H30H8V88Z",
    fill: "#D27723"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M8 88H52V102H8V88Z",
    fill: "#D27723"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M37 249H125V293H37V249Z",
    fill: "#F6F6F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 257,
    width: 28,
    height: 36,
    fill: "#D27723"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 257,
    width: 28,
    height: 36,
    fill: "#D27723"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 62,
    width: 40,
    height: 170,
    fill: "#D27723"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M8 62H52V76H30H8V62Z",
    fill: "#D27723"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M8 62H52V76H8V62Z",
    fill: "#D27723"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M8 114H52V128H30H8V114Z",
    fill: "#D27723"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M8 114H52V128H8V114Z",
    fill: "#D27723"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding2);
export default __webpack_public_path__ + "static/media/Building2.d1bfebc662d1b54bc40a129df8d76131.svg";
export { ForwardRef as ReactComponent };